import { API } from "aws-amplify";

const index = async (params) => {
    let myInit = { // OPTIONAL
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        queryStringParameters: params,
        headers: {} // OPTIONAL
    };
    let items = await API.get("InasakuAPI", "/api/informations", myInit);

    return items;
};
const insert = async (params) => {
    let myInit = {
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        body: {
            data: params
        },
        headers: {} // OPTIONAL
    };
    let res = await API.post("InasakuAPI", "/api/informations", myInit);

    return res;
};
const update = async (params) => {
    let myInit = {
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        body: {
            data: params
        },
        headers: {} // OPTIONAL
    };
    let res = await API.put("InasakuAPI", "/api/informations", myInit);

    return res;
};
const updateRead = async (params) => {
    let myInit = {
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        body: {
            data: params
        },
        headers: {} // OPTIONAL
    };
    let res = await API.put("InasakuAPI", "/api/informations/read", myInit);

    return res;
};
const del = async (params) => {
    let myInit = {
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        body: {
            data: params,
        }, // replace this with attributes you need
        headers: {} // OPTIONAL
    };

    let res = await API.del("InasakuAPI", `/api/informations`, myInit);

    return res;
};

export default {
    index: index,
    insert: insert,
    update: update,
    updateRead: updateRead,
    del: del,
};
